import React, { Component } from 'react';

class Sharedheader extends Component {
    constructor(props) {
        super(props);
      
    }
    render() {
        return (
            <div className="shared__header mt-5 d-flex align-items-center col-12 mx-3 px-0">
                       <img src={this.props.icon} width="80px" className='mr-4' alt="" />
                       <h1 className='shared__header__txt'>{this.props.name}</h1>
            </div>
        );
    }
}

export default Sharedheader;
